<template>
  <v-layout>
    <v-flex>
      <lookup-select
        label="Scopes of Practice"
        v-model="item.sopid"
        lookup-name="ScopesOfPractice"
      />
      <date-picker v-model="item.scopedate" label="Scope Start Date" />
      <v-switch
        :input-value="!item.isinactive"
        label="Active"
        @change="
          item.isinactive = !item.isinactive;
          item.inactivedate = item.isinactive ? new Date() : null;
          $forceUpdate();
        "
      />
      <date-picker
        v-model="item.inactivedate"
        label="Deactivated Date"
        v-if="item.isinactive"
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    item: Object,
    required: true
  }
};
</script>
